import { IRootState } from '../../../../store'
import { IVentilatorState } from '../store/ventilator.types'

export const getVentilatorSelector = (state: IRootState): IVentilatorState => state.ventilator
